import { Property } from 'bl-graphql'

export const isProperty = (value: string): value is Property => {
  return Object.values(Property).includes(value as Property)
}
